import { FCC } from "@dgs/core";
import { ContentContainer, FullScreenContainer, ScrollContainer } from "./view/ViewPageComponents";

export const ViewPageContentLayout: FCC = ({ children }) => {
	return (
		<FullScreenContainer>
			<ScrollContainer>{children}</ScrollContainer>
		</FullScreenContainer>
	);
};

export const DefaultContentLayout: FCC = ({ children }) => {
	return <ContentContainer>{children}</ContentContainer>;
};
